// styles.js (append the new styles at the end)

import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import styled from "styled-components/macro";

const StyledDrawer = styled(SwipeableDrawer)`
  .MuiDrawer-paper {
    background-color: var(--widget);
    box-shadow: var(--widget-shadow);
    padding: 30px;
    border: none;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .logo-wrapper {
      padding-bottom: 40px;
    }
  }
`;

const StyledAccordion = styled(Accordion)`
  background-color: transparent !important;
  box-shadow: none !important;

  &:before {
    display: none;
  }

  &.Mui-expanded {
    margin: 0 !important;
  }
`;

const StyledAccordionSummary = styled(AccordionSummary)`
  padding: 0 10px !important;
  min-height: unset !important;
  height: 40px;
  margin: 0 -10px !important;
  border-radius: 4px !important;
  transition: background-color var(--transition);

  .MuiAccordionSummary-content {
    margin: 0 !important;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .icon-chevron-down {
    will-change: transform;
    transition: all var(--transition);
    color: var(--text);
    font-size: 0.625rem;
  }

  &.Mui-expanded,
  &.active {
    background: var(--border);

    .icon-chevron-down {
      transform: rotate(180deg);
      color: var(--header);
    }
  }
`;

const StyledAccordionDetails = styled(AccordionDetails)`
  padding: 20px 10px 10px !important;
  display: flex;
  flex-direction: column;
  gap: 10px;

  a {
    color: var(--text);
    transition: all var(--transition);
    width: fit-content;
    font-family: var(--heading-font);
    font-weight: 500;
    font-size: 0.75rem;

    &:hover,
    &:focus,
    &.active {
      color: var(--header);
      text-shadow: 0 0 0 var(--header);
    }
  }
`;

const SingleLink = styled(StyledAccordionSummary)`
  display: flex;
  align-items: center;

  &.pinned {
    margin-top: 15px !important;
  }
`;

const Link = styled.span`
  color: var(--text);
  display: inline-flex;
  align-items: center;
  gap: 12px;
  transition: color var(--transition);
  height: fit-content;

  &:hover,
  &:focus,
  &.active {
    color: var(--header);
  }

  .icon {
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
  }
`;

/* ===== New styles for teams list ===== */

const ORANGE = "#FFA500";

const StyledTeamsBlock = styled.div`
  padding: 12px 16px;
  margin-top: 8px;
  margin-bottom: 8px;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);

  .teams-title {
    margin-bottom: 8px;
  }
  .teams-empty {
    opacity: 0.7;
    font-size: 14px;
  }
`;

const StyledTeamsList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  gap: 8px;
`;

/* Stacked (name on one line, league below), wrap when long */
const StyledTeamItem = styled.li`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  width: 100%;

  background: ${({ $active }) => ($active ? ORANGE : "transparent")};
  color: ${({ $active }) => ($active ? "#000" : ORANGE)};
  border-radius: ${({ $active }) => ($active ? "8px" : 0)};
  padding: ${({ $active }) => ($active ? "8px 10px" : 0)};
  cursor: ${({ $active }) => ($active ? "default" : "pointer")};

  .team-name,
  .league-code {
    width: 100%;
    white-space: normal;
    word-break: break-word;
    overflow-wrap: anywhere;
    line-height: 1.2;
  }

  &:not([aria-disabled="true"]):hover .team-name {
    text-decoration: underline;
  }
`;

export {
  Link,
  SingleLink,
  StyledAccordion,
  StyledAccordionDetails,
  StyledAccordionSummary,
  StyledDrawer,
  StyledTeamItem,
  StyledTeamsBlock,
  StyledTeamsList,
};
